import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, maxLength, ...props }, ref) => {
  const [length, setLength] = React.useState(() => (props.value || props.defaultValue || '').toString().length);
  const showCounter = maxLength && type !== "password" && type !== "hidden" && type !== "number";

  const handleChange = (e) => {
    if (showCounter) setLength(e.target.value.length);
    props.onChange?.(e);
  };

  React.useEffect(() => {
    if (showCounter && props.value !== undefined) {
      setLength(props.value.toString().length);
    }
  }, [props.value, showCounter]);

  if (!showCounter) {
    return (
      <input
        type={type}
        autoComplete="off"
        maxLength={maxLength}
        className={cn(
          "flex h-9 w-full rounded-md border border-white/20 bg-background px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props} />
    );
  }

  return (
    <div className="relative w-full">
      <input
        type={type}
        autoComplete="off"
        maxLength={maxLength}
        className={cn(
          "flex h-9 w-full rounded-md border border-white/20 bg-background px-3 py-1 pr-12 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
        onChange={handleChange} />
      <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-muted-foreground pointer-events-none">{length}/{maxLength}</span>
    </div>
  );
})
Input.displayName = "Input"

export { Input }
